//#region src/maitred_activity_source.ts
var MaitredActivitySource = /* @__PURE__ */ function(MaitredActivitySource) {
	MaitredActivitySource["Mcp"] = "mcp";
	return MaitredActivitySource;
}(MaitredActivitySource || {});
//#endregion
export { MaitredActivitySource };

//# sourceMappingURL=maitred_activity_source.js.map